var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.5,
    fill: "white",
    stroke: "#ffffff",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5174 49.7079C39.6202 47.3053 38.4916 44.4066 38.2587 44.1603C41.0374 42.4653 46.4719 40.3352 46.7762 37.279C47.1633 33.3301 39.5173 25.075 38.0516 25C34.04 25.0375 26.6983 30.9776 25.8282 32.7726C24.211 36.4839 25.0125 39.9377 27.7926 44.9378C31.3327 52.3755 44.4818 66.4844 52.0035 70.9132C56.9809 74.2558 60.6167 75.5681 64.9583 74.7758C66.9769 74.4408 74.2672 69.207 74.9972 65.6682C75.176 64.3556 66.7012 55.6543 62.3182 55.3093C58.9152 55.0343 55.6522 59.4918 53.3136 61.6706C53.0807 61.4106 51.0863 60.0493 48.9463 57.8943C46.1604 55.333 43.5718 52.3242 41.5174 49.7079Z",
    fill: "rgb(54, 63, 73)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPhone);
export default __webpack_public_path__ + "static/media/info_phone.9b0c0091bec11e7eeeb996dca3794eb1.svg";
export { ForwardRef as ReactComponent };